<template>
  <div class="category-component">
    <el-form ref="ruleForm" class="categoryForm">
      <el-form-item style="margin-bottom: 0">
        <el-input
          :placeholder="placeholder"
          v-model="catevalue"
          autocomplete="off"
          :clearable="clearable"
          @focus="dialogVisible = true"
          @clear="clear"
          :size="size"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <el-dialog  v-dialogDragOnly
      :title="placeholder"
      :visible.sync="dialogVisible"
      append-to-body
      custom-class="mini-dialog"
      :before-close="handleClose"
    >
      <parent-category v-if="dialogVisible" :categoryType="categoryType" :rid="rid" :parentId='value' :parentName='catevalue'  @setValue="setCategoryValue"></parent-category>
    </el-dialog>
  </div>
</template>

<script>
import ParentCategory from "~/common/components/custom/ParentCategory.vue";
export default {
  components: {
    ParentCategory
  },
  watch: {
    categoryValue(val) {
      //传进来的中文
      this.catevalue = val;
      this.$refs["ruleForm"].validate();
    },
    value(val) {
      //$parent 必须是el-form-item 否则递归寻找
      this.$parent.$emit("el.form.change");
      if (!val) {
        this.catevalue = '';
      }
    }
  },
  props: {
    value: {
      //父级v-model categ_parent_id
      type: [String, Number],
      default: () => ""
    },
    rid: {
      type: String,
      default: () => ""
    },
    categoryValue: {
      type: String,
      default: () => ""
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    //是哪一种类型，比如计费重系数，需要只能选择最后一级
    categoryType: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: () => "mini"
    },
    placeholder: {
      type: String,
      default: () => this.$t('portal.fu-lei')
    }
  },
  data() {
    return {
      dialogVisible: false,
      catevalue: ""
    };
  },
  created() {
    this.catevalue = this.categoryValue;
  },
  computed: {},
  methods: {
    handleClose() {
      this.$refs["ruleForm"].validate();
      this.dialogVisible = false;
    },
    setCategoryValue(node) {
      this.catevalue = node.label;
      this.$emit("input", node.id); //改变v-model值
      this.$emit("select", node.label); //中文
      this.$emit('callback', node.id, node.label);
      this.dialogVisible = false;
    },
    clear() {
      this.$emit("input", '');
    }
  }
};
</script>

<style lang="less" scoped>

</style>
